<!-- 线损 -->
<template>
	<div class="custom-scrollbar ownerManagerListBody" style="height: 100%;">
		<datePicker ref="datePickerBegin" :initDate='beginDate' @selectDate="beginDate = $event" type="day" style="z-index:10000;"></datePicker>
		<datePicker ref="datePickerEnd" :initDate='endDate' @selectDate="endDate = $event" type="day" style="z-index:10000;"></datePicker>
		<div class="searchContainer" style="margin:30px;">
			<el-form ref="form" label-width="90px" style="display: flex;align-items: center;">
				
				<el-form-item label="" style="height:300px;">
					<el-form-item label="起始日期">
						<el-date-picker v-model="beginDate" placeholder="任意时间点" style="width:150px"></el-date-picker>
					</el-form-item>
					<el-form-item label="时间(小时)">
						<el-time-select style="width:150px"
							v-model="startTime"
							:picker-options="{start: '00:00',step: '00:05',end: '59:59'}"
							placeholder="选择时间" >
						</el-time-select>
					</el-form-item>
					<elCheckBoxTree @checkItem="checkItemListLeft" :dataList='virtualDeviceList' style="height:400px;"></elCheckBoxTree>
				</el-form-item>

				<el-form-item label="">
					<el-form-item label="线损结果：" v-show="compairResult.length > 0">
						{{compairResult}}%
					</el-form-item>
					<el-button type="primary" size="mini" @click="confirm">比较</el-button>
				</el-form-item>

				<el-form-item label="" style="height:300px;">
					<el-form-item label="结束日期">
						<el-date-picker v-model="endDate" placeholder="任意时间点" style="width:150px"></el-date-picker>
					</el-form-item>
					<el-form-item label="时间(小时)">
						<el-time-select style="width:150px"
							v-model="endTime"
							:picker-options="{start: '00:00',step: '00:05',end: '59:59'}"
							placeholder="选择时间" >
						</el-time-select>
					</el-form-item>
					<elCheckBoxTree @checkItem="checkItemListRight" :dataList='virtualDeviceList' style="height:400px;"></elCheckBoxTree>
				</el-form-item>
				
			</el-form>
		</div>
	</div>
</template>
<script>
	import elCheckBoxTree from '@/page/projectDingZhi/ningbo/elCheckBoxTree.vue'
	import ownerManagerStore from '@/page/projectDingZhi/ningbo/workorderManagerStore.js'
	import electricMeterTree from '@/components/module/meterReading/electricMeterTree.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			elCheckBoxTree,
			electricMeterTree,
			iconButton,
			datePicker,
		},
		props: {},
		data() {
			return {
				beginDate: new Date(new Date().formatByDate()),
				endDate: new Date(new Date().formatByDate()),
				startTime: '00:00',
				endTime: '00:00',
				//比较结果
				compairResult: '',
				//设备列表
				deviceListNameLeft: '',
				deviceListNameRight: '',
				selectDeviceListLeft: {},
				selectDeviceListRight: {}, 
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			//设备列表
			deviceNos() {
				return ownerManagerStore.state.deviceNos
			},
			deviceListFilter() {
				var tree = copy(this.$store.deviceStore.getters.getReadDeviceTree)
				var meterTree = filterTreeRecursive([copy(tree)], item => {
					return !(item.entityName == "VirtualDevicePojo" && !this.deviceNos.includes(item.no))
				})
				let list = filterTreeRecursive(meterTree, item => {
					if(item.type == "group") {
						return true
					} else {
						return !this.bindedDeviceNos.includes(item.no)
					}
				})
				return deviceList(list)
			},
		},
		watch: {
			beginDate(nv, ov) {
				this.$refs.datePickerBegin.hide();
			},
			endDate(nv, ov) {
				this.$refs.datePickerEnd.hide();
			},
		},
		methods: {
			clickTimePicker: function(){
				alert('aabb');
			},
			getElementsClass(classnames){ 
				var classobj= new Array();//定义数组 
				var classint=0;//定义数组的下标 
				var tags=document.getElementsByTagName("*");//获取HTML的所有标签 
				for(var i in tags){//对标签进行遍历 
					if(tags[i].nodeType==1){//判断节点类型 
						if(tags[i].getAttribute("class") == classnames){//判断和需要CLASS名字相同的，并组成一个数组 
							classobj[classint]=tags[i]; 
							classint++; 
						} 
					} 
				
				} 
				return classobj;//返回组成的数组 
			},
			compair(){
				this.compaired = !this.compaired;
				this.compairList = [{result:'比较结果1'},{result:'比较结果2'}];
			},
			//设备列表
			checkItemListLeft(list) {
				this.selectDeviceListLeft = list
			},
			checkItemListRight(list) {
				this.selectDeviceListRight = list
			},
			confirm() {
				//先保存用户，再保存绑定的设备
				var deviceNoLeft = [];
				for(var i=0; i<this.selectDeviceListLeft.length; i++){
					if(this.selectDeviceListLeft[i]['type'] == 'group'){
						continue;
					}
					deviceNoLeft[deviceNoLeft.length] = this.selectDeviceListLeft[i].no;
				}
				var deviceNoRight = [];
				for(var i=0; i<this.selectDeviceListRight.length; i++){
					if(this.selectDeviceListRight[i]['type'] == 'group'){
						continue;
					}
					deviceNoRight[deviceNoRight.length] = this.selectDeviceListRight[i].no;
				}
				if(isempty(deviceNoLeft) || isempty(deviceNoRight)) {
					this.$message.error('请选择设备');
					return
				}
				this.$api.ningboApi.lossCompair(
					deviceNoLeft,
					deviceNoRight,
					new Date(this.beginDate.format('yyyy-MM-dd') + " " + this.startTime + ":00").getTime(),
					new Date(this.endDate.format('yyyy-MM-dd') + " " + this.endTime + ":00").getTime(), 
					respon => {
						this.compaired = true;
						this.compairResult = respon + '';
					}, failure => {
						if(failure == null){
							failure = '空数据';
						}
						this.$message({
							type: 'error',
							message: failure
						});
					}
				)
			},
		}
	}
</script>
